<template lang="pug">
form.image-upload(ref='form')
  .image-upload-wrap
    v-text-field(
      :label='label',
      v-model='name',
      prepend-icon='attach_file',
      hint='Допустимые форматы: jpg, png, gif, svg',
      persistent-hint
    )
    //- Триггер выбора файла
    input(@change='readFile', accept='image/*', type='file', ref='image')
  //- Контейнер для изображения
  v-card.d-flex.pb-3(v-if='image', flat, tile, @click='$emit("click-image")')
    v-img.grey.lighten-2(
      :src='image',
      :lazy-src='image',
      :aspect-ratio='ratio'
    )
      template(v-slot:placeholder)
        v-layout(fill-height, align-center, justify-center, ma-0)
          v-progress-circular(indeterminate, color='grey lighten-5')
  v-dialog(v-model='busy', persistent, width='280')
    v-card(color='primary', dark)
      v-card-text Загрузка файла
      v-progress-linear.mb-0(v-model='progress', color='white')
</template>

<script>
import http from '@/http'

export default {
  props: {
    label: {
      type: String,
      default: 'Выберите файл для загрузки',
    },
    src: String,
    parseResponse: {
      type: Function,
      default: (v) => v,
    },
    ratio: {
      type: Number,
      default: 16 / 9,
    },
  },

  data: () => ({
    name: null,
    image: null,
    preview: false,
    busy: false,
    hash: null,
    progress: 0,
  }),

  created() {
    this.image = this.src
  },

  methods: {
    async upload(file) {
      if (this.busy) return
      this.busy = true

      let formdata = new FormData()
      let extension = file.name.split('.').pop()
      formdata.append('editor', file, `attach.${extension}`)

      try {
        let response = await http.post('/files/upload/ckeditor', formdata, {
          onUploadProgress: (progressEvent) => {
            let totalLength = progressEvent.lengthComputable
              ? progressEvent.total
              : progressEvent.target.getResponseHeader('content-length') ||
                progressEvent.target.getResponseHeader(
                  'x-decompressed-content-length'
                )
            if (totalLength !== null) {
              let progress = Math.round(
                (progressEvent.loaded * 100) / totalLength
              )
              this.progress = progress
              this.$emit('upload-progress', progress)
            }
          },
        })
        this.$emit('input', this.parseResponse(response.data))
        this.$emit('upload-success', response.data)
      } catch (error) {
        this.$emit('upload-error', error)
      }

      this.busy = false
    },

    readFile(event) {
      let imageType = /image.*/
      let file = event.target.files[0]

      if (file && file.type.match(imageType)) {
        this.name = file.name

        this.$refs.form.reset()
        let reader = new FileReader()

        reader.onload = () => {
          this.image = reader.result
        }

        reader.readAsDataURL(file)
        this.upload(file)
      } else {
        this.$root.showSnack('Неподдерживаемый формат файла')
      }
    },
  },

  watch: {
    src(val) {
      this.image = val
    },
  },
}
</script>

<style scoped>
.image-upload-wrap {
  overflow: hidden;
  position: relative;
}
.image-upload [type='file'] {
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 50px;
  position: absolute;
}
.image-upload-preview {
  padding-bottom: 48px;
  overflow: hidden;
  pointer-events: none;
}
.controls {
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2;
  position: absolute !important;
  background: white;
  display: flex;
  align-items: flex-end;
  pointer-events: auto;
}
.extension {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
}
</style>
